import React, { useEffect, useState } from "react";
import { Drawer, Button, Tooltip } from "antd";
import "antd/dist/antd.css";
import "./Utils.css";
import { CloseOutlined } from "@ant-design/icons";

const FullScreenDashboard = ({ open, onClose, children }) => {
  const [fadeClass, setFadeClass] = useState("");

  useEffect(() => {
    if (open) {
      setFadeClass("fade-in");
    } else {
      setFadeClass("");
    }
  }, [open]);

  return (
    <>
      <style>
        {`
          .fade-in {
            opacity: 0;
            animation: fadeIn 0.5s ease forwards;
          }

          @keyframes fadeIn {
            from { opacity: 0; transform: translateY(10px); }
            to { opacity: 1; transform: translateY(0); }
          }
        `}
      </style>

      <Drawer
        visible={open}
        onClose={onClose}
        closable={false}
        placement="top"
        height="100vh"
        bodyStyle={{
          backgroundColor: "#ffffff",
          padding: 0,
          overflow: "auto",
        }}
        style={{
          top: 0,
        }}
      >
        <div
          style={{
            position: "absolute",
            top: 20,
            right: 30,
            zIndex: 1000,
          }}
        >
          <Tooltip title="Cerrar ventana">
            <Button
              onClick={(e) => {
                const target = e.currentTarget;
                const ripple = document.createElement("span");
                const rect = target.getBoundingClientRect();

                ripple.className = "ripple";
                ripple.style.left = `${e.clientX - rect.left}px`;
                ripple.style.top = `${e.clientY - rect.top}px`;

                target.appendChild(ripple);

                setTimeout(() => {
                  ripple.remove();
                }, 600);

                onClose();
              }}
              type="text"
              className="fade-in-button ripple-button"
              style={{
                width: "40px",
                height: "40px",
                borderRadius: "50%",
                backgroundColor: "rgba(60, 60, 60, 0.9)",
                color: "#fff",
                fontSize: "16px",
                border: "none",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                backdropFilter: "blur(4px)",
                boxShadow: "0 2px 6px rgba(0, 0, 0, 0.2)",
                cursor: "pointer",
                transition: "all 0.3s ease",
                position: "relative",
                overflow: "hidden",
              }}
              onMouseEnter={(e) =>
                (e.currentTarget.style.backgroundColor =
                  "rgba(80, 80, 80, 0.95)")
              }
              onMouseLeave={(e) =>
                (e.currentTarget.style.backgroundColor =
                  "rgba(60, 60, 60, 0.9)")
              }
            >
              <CloseOutlined />
            </Button>
          </Tooltip>
        </div>

        <div
          className={fadeClass}
          style={{
            padding: "80px 40px 40px 40px",
            fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
            color: "#333333",
          }}
        >
          {children}
        </div>
      </Drawer>
    </>
  );
};

export default FullScreenDashboard;
